import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { activeMock, hideHeader } from './../guards'

import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { PYMES_HEALTH_RATER_ROUTES } from './../pymes/pymesHealthRoutes'

const PYMES_ROUTER_BASE_PATH =
  import.meta.env.BASE_URL + import.meta.env.VITE_SERVER_PYMES_BASE_FOLDER

export function createPymesRouter() {
  const router = createRouter({
    history: createWebHistory(PYMES_ROUTER_BASE_PATH),
    routes: [
      {
        path: '/',
        name: 'pymes',
        component: () => import('../../modules/common/common/views/IndexView.vue'),
        meta: {
          title: 'Calcula el Precio de los Seguros para Autónomos y Pymes ASISA | ASISA',
          description:
            'Encuentra el precio de todos los seguros para Autónomos y Pymes ASISA con nuestro tarificador. Compara todas las tarifas de ASISA de forma rápida y fácil.',
          phone: '917 619 300',
          isPymes: true
        },
        children: [
          {
            path: '',
            name: 'rater-nav-pymes',
            component: () => import('../../modules/common/common/views/NavView.vue'),
            beforeEnter: () => {
              useLoadingStore().startLoading('common.loading.processing')
            }
          },
          {
            path: '/exit',
            name: 'exit',
            beforeEnter: () => {
              const urlDxpBack =
                import.meta.env.VITE_API_URL_DXP_ROOT + import.meta.env.VITE_PYMES_URL_PATH_HOME
              window.location.replace(urlDxpBack || 'https://www.asisa.es/autonomos-pymes')
            }
          },
          ...PYMES_HEALTH_RATER_ROUTES
        ] as RouteRecordRaw[]
      },
      {
        path: '/rater-nav',
        name: 'rater-nav',
        redirect: '/'
      },
      {
        path: '/:pathMatch(.*)*',
        redirect: '/'
      }
    ]
  })

  router.beforeEach(async (to: any /*from: any*/) => {
    if (to.path === '/components' && window.location.hostname !== '127.0.0.1') {
      return '/salud'
    }
    if (to.query && to.query.showHeader === 'false') {
      hideHeader()
    }
    //TODO: COMMENTS BY ENVIRONMENT
    if (to.query && to.query.mock === 'true') {
      activeMock()
    }
  })

  return router
}

export default createPymesRouter()
